import type { GetMyCampaignStatusesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import {
  R7_MARUMORI_CAMPAIGN_END_DATE,
  R7_MARUMORI_CAMPAIGN_START_DATE,
} from "../../../config";
import type { TenantWithFeature } from "../../../libs/connect";
import { getIsInTargetCity } from "../../../libs/tenant";

export type R7MarumoriCampaignBannerType =
  | "not-applied" // 未応募バナー
  | "applied" // 応募済みバナー
  | "ineligible" // 対象外バナー（昨年度応募済み）
  | "campaign-ended" // キャンペーン終了バナー
  | "hidden"; // バナー非表示

export function getR7MarumoriCampaignBannerType(
  campaignStatuses: GetMyCampaignStatusesResponse | null,
  currentDate: Date,
  tenant: TenantWithFeature,
  cityAddress: string,
): R7MarumoriCampaignBannerType {
  // marumoriテナント以外の場合は非表示
  if (tenant.slug !== "marumori") {
    return "hidden";
  }

  // キャンペーン期間外の場合は非表示
  if (
    currentDate < R7_MARUMORI_CAMPAIGN_START_DATE ||
    currentDate > R7_MARUMORI_CAMPAIGN_END_DATE
  ) {
    return "hidden";
  }

  // 対象エリア外の場合は非表示
  if (!getIsInTargetCity(tenant, cityAddress)) {
    return "hidden";
  }

  // APIレスポンスがない場合は非表示
  if (!campaignStatuses) {
    return "hidden";
  }

  const { r6Primary, r7OnSignup } = campaignStatuses;

  // 昨年度キャンペーン（r6Primary）に応募済みの場合は対象外
  if (r6Primary?.isApplied) {
    return "ineligible";
  }

  // r7OnSignupに応募済みの場合は応募済みバナー
  if (r7OnSignup?.isApplied) {
    return "applied";
  }

  // r7OnSignup.isWinLimitReached の場合はキャンペーン終了バナー表示
  if (r7OnSignup?.isWinLimitReached) {
    return "campaign-ended";
  }

  // すべての条件を満たす場合は未応募バナー
  return "not-applied";
}
